import { render, staticRenderFns } from "./PrizeRequest.vue?vue&type=template&id=05444fbc&"
import script from "./PrizeRequest.vue?vue&type=script&lang=js&"
export * from "./PrizeRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports